import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Client } from '../../../core/models/clients.model';
import { ClientService } from '../../../core/services/client.service';

@Component({
  selector: 'app-client-finder',
  templateUrl: './client-finder.component.html',
  styleUrls: [ './client-finder.component.scss' ]
})
export class ClientFinderComponent implements OnInit {

  @Output() search: EventEmitter<any> = new EventEmitter<any>();

  public formSearcher = new UntypedFormGroup({ search: new UntypedFormControl('') });

  private clients: Client[] = [];

  constructor(
    private client$: ClientService
  ) {
    this.clients = this.client$.clients;
  }

  ngOnInit(): void {
  }

  onSubmit(): void {
    const toSearch = this.formSearcher.controls.search.value
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

    const clients = Object.keys(this.clients).filter(f => {
      const client = this.clients[f];

      return `${ client.name } ${ client.lastname1 } ${ client.lastname2 }`
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .includes(toSearch);
    }).map(m => this.clients[m]);

    this.search.next(clients);
  }

  onReset(): void {
    this.formSearcher.reset();
    this.search.next([]);
  }
}
